import { ConversionError } from '../../error/ConversionError';
import { AbstractIOConverter } from '../module';
/**
 * Convert 0 1 numbers to booleans and back
 *
 * Rejects numbers that are not 1 or 0
 *
 * @example
 * 1 => true
 * 0 => false
 */
export class NumberToBoolean extends AbstractIOConverter {
    static toServerFormat(input) {
        if (input) {
            return 1;
        }
        else {
            return 0;
        }
    }
    static toClientFormat(input) {
        if (input === 1) {
            return true;
        }
        else if (input === 0) {
            return false;
        }
        else {
            throw new ConversionError(`Input ${input} is not 1 or 0 and can't be converted!`, 'toClient');
        }
    }
}
